module.exports = __webpack_public_path__ + "images/kihnu/ms-icon-150x150.png";